import { eThietLapChuanDauRaActionsObj } from "../../action-types/xet-chung-chi/IThietLapChuanDauRaActions";
import { generateActions } from "../generateActions";

export const thietLapChuanDauRaActions = {
    ...generateActions(eThietLapChuanDauRaActionsObj, "THIET_LAP_CHUAN_DAU_RA"),
}